import { render, staticRenderFns } from "./discordTalkroom3.vue?vue&type=template&id=7b510d7c&scoped=true"
import script from "./discordTalkroom3.vue?vue&type=script&lang=js"
export * from "./discordTalkroom3.vue?vue&type=script&lang=js"
import style0 from "./discordTalkroom3.vue?vue&type=style&index=0&id=7b510d7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b510d7c",
  null
  
)

export default component.exports